import moment from "moment";
import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
} from "reactstrap";
import DateTimePicker from "react-datetime-picker";

const DATE_FORMAT = "MM/dd/yy hh:mm a";

class DatePicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      from: moment().subtract(1, "hours").toDate(),
      to: moment().toDate(),
    };
  }

  render() {
    const { value } = this.props;
    const { showModal, from, to } = this.state;

    const toggleModal = () => this.setState({ showModal: !showModal });

    const clear = () => {
      this.setState({ showModal: false });
      this.props.update(null);
    };

    const update = () => {
      this.setState({ showModal: false });
      this.props.update({
        from: this.state.from,
        to: this.state.to,
      });
    };

    return (
      <div>
        <button
          className="user-input-fields user-input-fields-left"
          onClick={value ? clear : toggleModal}
        >
          {value ? "Clear" : "Select"}
        </button>
        <Modal
          className="user-modal datetimeModal"
          centered={true}
          zIndex={999999}
          isOpen={showModal}
          toggle={toggleModal}
        >
          <ModalHeader toggle={toggleModal}>Select Date and Time</ModalHeader>
          <ModalBody>
            <Row>
              <Col>
                <div className="date-outer">
                  <h6 className="title-label">Start Date</h6>
                  <DateTimePicker
                    format={DATE_FORMAT}
                    clearIcon={null}
                    required={true}
                    value={from}
                    onChange={(from) => this.setState({ from })}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="date-outer">
                  <h6 className="title-label">End Date</h6>
                  <DateTimePicker
                    format={DATE_FORMAT}
                    clearIcon={null}
                    required={true}
                    value={to}
                    onChange={(to) => this.setState({ to })}
                  />
                </div>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <button
              size="sm"
              color="basic"
              className="cancel-bttn"
              onClick={toggleModal}
            >
              Cancel
            </button>
            <button
              className="update-bttn"
              onClick={() => update(from, to)}
              size="sm"
              color="primary"
            >
              Update
            </button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default ({ filter, onChange }) => (
  <DatePicker value={filter ? filter.value : null} update={onChange} />
);
